import { render } from "./ProductDetailAttributes.vue?vue&type=template&id=01714e85&scoped=true"
import script from "./ProductDetailAttributes.vue?vue&type=script&lang=js"
export * from "./ProductDetailAttributes.vue?vue&type=script&lang=js"

import "./ProductDetailAttributes.vue?vue&type=style&index=0&id=01714e85&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01714e85"]])

export default __exports__